import { Form } from 'antd';
// import BaseInput from 'basic-ui-lib/components/Input/BaseInput';
import BaseModal from 'basic-ui-lib/components/Modal/BaseModal';
import { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import UploadFile, { UploadFileProps } from './UploadFile';
import { setPageLoading } from 'widgets/PageLoading';
import mediaApis from 'modules/media/services/apis';
import { toast } from 'react-toastify';
import { getMessageError } from 'services/response';
import Box from 'basic-ui-lib/components/Box/Box';
import { Col, Text } from 'basic-ui-lib';

export interface UploadImageOrVideoModalRef {
  open: (currentPath: string) => void;
}
interface Props {
  onSuccess: (currentPath: string) => void;
}

interface FormValues {
  file: UploadFileProps['value'];
}
const UploadImageOrVideoModal = forwardRef<UploadImageOrVideoModalRef, Props>(({ onSuccess }, ref) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState(' ');
  // const [, mutate] = useGetManageLibrary(true);

  useImperativeHandle(ref, () => ({
    open: (currentPath: string) => {
      setCurrentPath(currentPath);
      setIsOpen(true);
    },
  }));

  const onClose = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleFinish = async (values: FormValues) => {

    const formData = new FormData();
    if (values.file?.file) {
      formData.append('file', values.file.file);
    }
    formData.append('path', currentPath);

    try {
      setPageLoading(true);

      const res = await mediaApis.uploadMediaItem(formData);

      if (res?.data?.data) {
        toast.success('Upload successful');
        onSuccess(currentPath);
        onClose();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Upload failed');
    } finally {
      setPageLoading(false);
    }
  };
  return (
    <BaseModal
      title='Upload Image/Video'
      isOpen={isOpen}
      width={1000}
      onClose={onClose}
      okText='Continue'
      onOk={handleSubmit}
    >
      <Container>
        <Form layout='vertical' form={form} onFinish={handleFinish}>
          {/* <Form.Item name='name' rules={[{ required: true, message: 'Please input channel name' }]}>
            <BaseInput placeholder='Please enter name' />
          </Form.Item> */}
          <Box display='flex' flexDirection='column' padding='0 60px'>
            <Form.Item name='file' rules={[{ required: true, message: 'Please upload image or video' }]}>
              <UploadFile />
            </Form.Item>
            <Col gap={0}>
              <Text content_1 center color='neutral.text.3'>
                We support PNG, JPEG, JPG, MP4, GIF
              </Text>
              <Text content_1 center color='neutral.text.3'>
                Portrait (1080×1920) or landscape (1920×1080) for best quality
              </Text>
            </Col>
          </Box>
        </Form>
      </Container>
    </BaseModal>
  );
});

UploadImageOrVideoModal.displayName = 'UploadImageOrVideoModal';
export default UploadImageOrVideoModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0 150px 24px;
`;
